import { render } from "./AvaliacaoTrauma.vue?vue&type=template&id=29045ca8&scoped=true"
import script from "./AvaliacaoTrauma.vue?vue&type=script&lang=js"
export * from "./AvaliacaoTrauma.vue?vue&type=script&lang=js"

import "./AvaliacaoTrauma.vue?vue&type=style&index=0&id=29045ca8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29045ca8"]])

export default __exports__